export const contactsData = {
    email: 'goudaanand65@gmail.com',
    phone: '+91-7377187718',
    address: 'Berhampur, Ganjam, Odisha, India - 761054 ',

    sheetAPI: ''
}